module.exports = __webpack_public_path__ + "static/media/Tejarat.27e5b609.svg";